import { createFileRoute } from "@tanstack/react-router";
import { EventDetail } from "@/components/Distributions/Admin/Events/Investments";
import BackButton from "@/components/GoBack";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  const id = params?.eventId as string;
  const distributionId = params?.id as string;
  return (
    <>
      <BackButton />
      <EventDetail eventId={id} distributionId={distributionId} />
    </>
  );
}

export const Route = createFileRoute(
  "/_authenticated/distributions/$id/distributions-events/$eventId/",
)({
  component: RouteComponent,
  staticData: { page: ["distributions", "deals"] },
});
